import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import HeaderComponent from "../components/HeaderComponent";
import SiteFooter from "../components/SiteFooter";
import {
  navLinks,
  serviceOfferings,
  serviceProcess,
} from "../data/siteContent";

function ServicesPage() {
  const navigate = useNavigate();
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  useEffect(() => {
    document.body.classList.add("services-page");

    return () => {
      document.body.classList.remove("services-page");
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      document.body.classList.toggle("scrolled", window.scrollY > 100);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.body.classList.remove("scrolled");
    };
  }, []);

  useEffect(() => {
    document.body.classList.toggle("mobile-nav-active", isMobileNavOpen);

    return () => {
      document.body.classList.remove("mobile-nav-active");
    };
  }, [isMobileNavOpen]);

  const handleNavClick = (sectionId) => {
    setIsMobileNavOpen(false);
    navigate({ pathname: "/", hash: `#${sectionId}` });
  };

  const toggleMobileNav = () => {
    setIsMobileNavOpen((currentValue) => !currentValue);
  };

  return (
    <>
      <HeaderComponent
        activeSection=""
        isMobileNavOpen={isMobileNavOpen}
        navLinks={navLinks}
        onNavigate={handleNavClick}
        onToggleMobileNav={toggleMobileNav}
        getSectionHref={(sectionId) => `/#${sectionId}`}
      />

      <section className="section services-page-shell">
        <div className="container services-page-container">
          {/* Hero Section - Improved spacing and alignment */}
          <div className="services-page-hero">
            <div className="text-center text-lg-start">
              <span className="project-status-pill">Our Services</span>
              <h1 className="mt-3 mb-4">
                Practical support across software, operations, brand, and sourcing.
              </h1>
              <p className="services-page-lead mb-4">
                Operating Software works with businesses that need tailored digital solutions and hands-on support around execution.
              </p>
              <div className="project-detail-actions justify-content-center justify-content-lg-start">
                <a href="/#contact" className="btn-get-started">
                  <i className="bi bi-chat-dots me-2"></i>
                  Start a conversation
                </a>
                <Link to="/" className="btn-watch-video d-inline-flex align-items-center">
                  <i className="bi bi-arrow-left me-2"></i>
                  <span>Back to homepage</span>
                </Link>
              </div>
            </div>
          </div>

          {/* Services Section - Enhanced grid layout */}
          <section className="services-page-section">
            <div className="section-title text-center mb-5">
              <h2 className="position-relative d-inline-block pb-2">What We Offer</h2>
              <p className="mt-3 mx-auto" style={{ maxWidth: "600px" }}>
                Our services are built around practical business needs, not one-size-fits-all packages.
              </p>
            </div>

            <div className="row gy-4">
              {serviceOfferings.map((service, index) => (
                <div className="col-lg-6" key={service.slug}>
                  <article className="project-detail-card service-offering-card h-100">
                    <div className="service-offering-icon">
                      <i className={`bi ${service.icon}`}></i>
                    </div>
                    <h3 className="mt-2 mb-3">{service.title}</h3>
                    <p className="service-offering-summary">{service.summary}</p>
                    <p className="text-muted">{service.description}</p>
                    <ul className="project-detail-list mt-3">
                      {service.deliverables.map((item) => (
                        <li key={item}>
                          <i className="bi bi-check-circle-fill"></i>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </article>
                </div>
              ))}
            </div>
          </section>

          {/* Process Section - Improved visual hierarchy */}
          <section className="services-page-section">
            <div className="section-title text-center mb-5">
              <h2 className="position-relative d-inline-block pb-2">How We Work</h2>
              <p className="mt-3 mx-auto" style={{ maxWidth: "600px" }}>
                We try to keep the process direct, collaborative, and focused on useful outcomes.
              </p>
            </div>

            <div className="row gy-4">
              {serviceProcess.map((step, index) => (
                <div className="col-lg-3 col-md-6" key={step.title}>
                  <article className="project-detail-card service-process-card h-100 text-center text-md-start">
                    <span className="service-process-number d-block">{`0${index + 1}`}</span>
                    <h3 className="h5 mb-3">{step.title}</h3>
                    <p className="text-muted small">{step.description}</p>
                  </article>
                </div>
              ))}
            </div>
          </section>

          {/* CTA Section - Better spacing and visual separation */}
          <section className="project-detail-card project-contact-card mt-5">
            <div className="text-center">
              <h2 className="mb-3">Need one of these services?</h2>
              <p className="mb-4 mx-auto" style={{ maxWidth: "600px" }}>
                If you already know what you need or want help figuring out the right direction, 
                reach out and we can map the next step together.
              </p>
              <div className="project-detail-actions justify-content-center">
                <a href="/#contact" className="btn-get-started">
                  <i className="bi bi-envelope me-2"></i>
                  Contact Operating Software
                </a>
              </div>
            </div>
          </section>
        </div>
      </section>

      <SiteFooter />
    </>
  );
}

export default ServicesPage;
